import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_v_menu = _resolveComponent("v-menu")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_menu, _mergeProps(_ctx.$attrs, {
      modelValue: _ctx.menu,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.menu) = $event)),
      "close-on-content-click": false,
      transition: "scale-transition",
      location: "bottom",
      "min-width": "0",
      width: "auto"
    }), _createSlots({
      default: _withCtx(() => [
        _createVNode(_component_v_date_picker, {
          modelValue: _ctx.value,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = $event => ((_ctx.value) = $event)),
            _cache[3] || (_cache[3] = $event => (_ctx.menu = false))
          ],
          "hide-header": "",
          min: _ctx.minDateValue,
          max: _ctx.maxDateValue
        }, null, 8, ["modelValue", "min", "max"])
      ]),
      _: 2
    }, [
      (_ctx.allowFieldInput)
        ? {
            name: "activator",
            fn: _withCtx(({ props }) => [
              _createVNode(_component_v_text_field, _mergeProps({ ..._ctx.$attrs, ...props }, {
                modelValue: _ctx.inputDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.inputDate) = $event)),
                clearable: "",
                class: "date-picker",
                "append-inner-icon": "mdi-calendar",
                variant: "outlined",
                type: "date",
                max: "9999-12-31",
                "hide-details": ""
              }), null, 16, ["modelValue"])
            ]),
            key: "0"
          }
        : {
            name: "activator",
            fn: _withCtx(({ props }) => [
              _createVNode(_component_v_text_field, _mergeProps({ ..._ctx.$attrs, ...props }, {
                modelValue: _ctx.displayValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.displayValue) = $event)),
                rules: _ctx.dateRules,
                "append-inner-icon": "mdi-calendar",
                readonly: "",
                variant: "outlined",
                "hide-details": ""
              }), null, 16, ["modelValue", "rules"])
            ]),
            key: "1"
          }
    ]), 1040, ["modelValue"])
  ]))
}